<div class="container" mat-dialog-content>
    <h2>Rename Category</h2>

    <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="category.nicename">
        <mat-hint>Avoid purals</mat-hint>
    </mat-form-field>

    <div>
        <mat-checkbox [(ngModel)]="indented">Indented</mat-checkbox>
    </div>
</div>

<div class="footer" mat-dialog-actions>
    <div class="left">
        <button mat-dialog-close mat-raised-button>Close</button>
    </div>
    <div class="right">
        <button (click)="save()" mat-raised-button>Save</button>
    </div>
</div>